<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('questions.title')" icon="briefcase">
            <app-default-button
                v-if="$can('create_question')"
                :title="$addLabel('question')"
                @click="openquestionModal()"
            />
        </app-page-top-section>

        <app-table
            id="question-table"
            :options="options"
            @action="triggerActions"
        />

        <app-question-modal
            v-if="isQuestionModalActive"
            v-model="isQuestionModalActive"
            :selected-url="selectedUrl"
            />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('question-table')"
            @cancelled="cancelled"
        />


    </div>
</template>

<script>
import QuestionMixin from "../../../Mixins/Learning/QuestionMixin";
import {urlGenerator} from "../../../../../common/Helper/AxiosHelper";
import {QUESTION_VIEW} from "../../../../Config/ApiUrl";

export default {
    name: "Questions",
    mixins: [QuestionMixin],
    props: {
        props: {
            default: ''
        },
        question_id: {
            type: String,
        }
    },
    data() {
        return {
            question: '',
            questionsId: '',
            questions: [],
            selectedUrl: '',
            modalClass: '',
            promptIcon: '',
            promptSubtitle: '',
            title: '',
            course_id: '',
            video_url: '',
            order: '',
            isQuestionModalActive: false,
            confirmationModalActive: false,
            isEmployeeMovementModalActive: false,
        }
    },
    created() {
        this.$store.dispatch( 'question')
    },
    watch: {
        isQuestionModalActive: function (value) {
            if (!value) {
                this.selectedUrl = '';
            }
        }
    },
    methods: {
        openquestionModal() {
            this.selectedUrl = '';
            this.isQuestionModalActive = true;
        },
        triggerActions(row, action, active) {
            this.questionsId = row.id;
            this.promptIcon = action.icon;
            this.modalClass = action.modalClass;
            this.promptSubtitle = action.promptSubtitle;

            if (action.name === 'edit') {
                this.selectedUrl = `${action.url}/${row.id}`;
                this.isQuestionModalActive = true;
            } else if (action.key === 'view_details') {
                window.location = urlGenerator(`${QUESTION_VIEW}/${row.id}`)
            } else {
                this.getAction(row, action, active)
            }
        },
        cancelled() {
            this.confirmationModalActive = false;
        },
    }
}
</script>
